import { render } from "./Registration.vue?vue&type=template&id=b15af648"
import script from "./Registration.vue?vue&type=script&lang=ts"
export * from "./Registration.vue?vue&type=script&lang=ts"
script.render = render

export default script